import { OperatorFunction } from 'rxjs';
import { filter } from 'rxjs/operators';

/**
 * Filter not defined values in stream
 */
export function filterDefined<T>(): OperatorFunction<
  T,
  Exclude<T, null | undefined>
> {
  return filter(
    (value): value is Exclude<T, null | undefined> =>
      value !== null && value !== undefined,
  );
}
